import ApiService from './api.service'
import { HTTP_STATUS_CODES } from '@/configs/constants.ts'

const ShopService = {
  async loadShopLimitList() {
    try {
      const response = await ApiService.get('shop-limit-list')
      if ((response.status = HTTP_STATUS_CODES.OK)) {
        return response.data
      }
    } catch (error) {
      return error.response
    }
  },
  async newLimit(data) {
    try {
      return await ApiService.post('admin/shop/limit', data)
    } catch (error) {
      return error.response
    }
  },
  async deleteShopLimit(id) {
    try {
      return await ApiService.delete(`admin/shop/limit/delete/${id}`)
    } catch (error) {
      return error.response
    }
  }
}

export { ShopService }
